import * as _4 from 'lodash';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../plan/constants/event_names';

export class CourseGroupMmTile {
  private isGroupExpanded: boolean = false;
  private groupIconAngle: string = '0';
  private genericSlot: any = {};
  private disableDND = false;
  private isPast = false;
  private isEditable: boolean | string;
  private isPlannedCourseWithSlots: boolean | string;
  private isPlaceholder: boolean | string;
  private plannedCourseId = INVALID_ID;
  private termId = INVALID_ID;
  private isFromTerm: boolean | string;
  constructor(private ngComponentCommunicatorService: CommunicatorService) {}
  $onChanges() {
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
    this.isPlannedCourseWithSlots = _4.isBoolean(this.isPlannedCourseWithSlots)
      ? this.isPlannedCourseWithSlots
      : this.isPlannedCourseWithSlots === 'true';
    this.isPlaceholder = _4.isBoolean(this.isPlaceholder) ? this.isPlaceholder : this.isPlaceholder === 'true';
    this.isFromTerm = _4.isBoolean(this.isFromTerm) ? this.isFromTerm : this.isFromTerm === 'true';
    this.disableDND = this.isFromTerm;
    if (this.isPlannedCourseWithSlots) {
      this.plannedCourseId = _4.get(this.genericSlot, 'course_id', INVALID_ID);
    }
  }

  emphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
  }
  deEmphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
  }
  toggleGroupExpandCollapse() {
    this.isGroupExpanded = !this.isGroupExpanded;
    this.groupIconAngle = this.isGroupExpanded ? '90' : '0';
  }
  dndData(course: any) {
    return {
      slotId: _4.get(course, 'slotId', INVALID_ID),
      courseId: _4.get(course, 'id', INVALID_ID),
      courseGroupId: _4.get(this.genericSlot, 'courseGroupId', INVALID_ID),
      slotType: 'COURSE',
      isFromTerm: false
    };
  }
}

angular.module('capability-ng-academic-planner').component('courseGroupMmTile', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/course_group_tile/course_group_mm_tile.html',
  bindings: {
    genericSlot: '<',
    isEditable: '<?',
    isFromTerm: '<',
    isPlannedCourseWithSlots: '<',
    isPlaceholder: '<',
    termId: '<?',
    isPast: '<?'
  },
  controller: CourseGroupMmTile
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_group_tile/course_group_mm_tile.ts